var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import iconSizes from '../../iconSizes';
/**
 * AlertTriangleIcon
 */
var AlertTriangleIcon = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.color, color = _d === void 0 ? 'black' : _d, title = _a.title;
    return (_jsxs("svg", __assign({ focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: '0 0 32 32', style: { width: iconSizes[size], height: iconSizes[size] }, role: "img", "aria-hidden": (_b = !title) !== null && _b !== void 0 ? _b : false }, { children: [title && _jsx("title", { children: title }, void 0),
            _jsx("g", __assign({ style: { fill: color } }, { children: _jsxs("svg", __assign({ viewBox: "0 0 24 24" }, { children: [_jsx("path", { d: "M23 17.5L14.5 3.3c-.9-1.3-2.7-1.8-4.1-1-.4.3-.7.6-1 1L.9 17.5c-.4.7-.5 1.5-.3 2.3.2.8.7 1.4 1.3 1.8.5.3 1 .5 1.6.5h16.9c1.7 0 3-1.3 3-3 0-.6-.2-1.2-.4-1.6zM20.4 20H3.5c-.2 0-.3 0-.5-.2-.2-.1-.4-.3-.4-.6 0-.2-.1-.4.1-.7l8.5-14.1c.1-.2.2-.3.3-.4.5-.3 1.1-.1 1.4.3l8.4 14.1c.1.1.1.3.1.4 0 .8-.4 1.2-1 1.2zM12 8c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1s1-.4 1-1V9c0-.6-.4-1-1-1zm0 10.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z" }, void 0),
                        _jsx("use", {}, void 0)] }), void 0) }), void 0)] }), void 0));
};
export default AlertTriangleIcon;
